/* global filter_obj */
const $ = jQuery.noConflict();
$(document).ready(function () {

	let is_loading = false;

	/** Load More Blog */
	$(document).off('click', '.blog-listing-component .load-more-blog').on('click', '.blog-listing-component .load-more-blog', function () {
		if (is_loading) {
			return;
		}

		const $component = $('.blog-listing-component');
		$component.find('.no-more-result').hide();
		$component.find('.load-more-img').css('display', 'flex');
		$component.find('.load-more-link').hide();

		const posts_per_page = $component.find('#posts_per_page').val();
		const selected_post_type = $component.find('#selected_post_type').val() || 'post';
		const row_start_index = parseInt($component.find('#current_row_index').val()) || 0;
		const input_page_num = parseInt($component.find('#input_page_num').text()) + 1;
		$component.find('#input_page_num').text(input_page_num);

		is_loading = true;
		ajax_news_filter(input_page_num, posts_per_page, selected_post_type, row_start_index, function () {
			is_loading = false;
		});
	});

});

function ajax_news_filter(input_page_num, posts_per_page, selected_post_type, row_start_index, callback) {
	const $component = $('.blog-listing-component');

	jQuery.ajax({
		url: filter_obj.ajax_url,
		type: 'POST',
		dataType: 'json',
		data: {
			action: 'ajax_news_filter',
			input_page_num: input_page_num,
			posts_per_page: posts_per_page,
			selected_post_type: selected_post_type,
			row_start_index: row_start_index,
		},
		beforeSend: function () {
			$component.find('.load-more-link').hide();
			$component.find('.load-more-img').css('display', 'flex');
		},
		success: function (res) {
			$component.find('.load-more-img').hide();
			$component.find('.load-more-link').show();

			if (res.html && res.html.trim() !== '') {
				// Append new post cards directly to the grid container
				$component.find('.blog-posts-grid').append(res.html);
			} else {
				$component.find('.load-more-link').hide();
			}

			if (res.next === 0) {
				$component.find('.load-more-link').hide();
			}

			if (typeof callback === 'function') {
				callback();
			}
		},
		error: function () {
			$component.find('.load-more-img').hide();
			$component.find('.no-more-result').show().text('Something went wrong.');
			if (typeof callback === 'function') {
				callback();
			}
		},
	});
}
